/* eslint-disable @typescript-eslint/no-unsafe-return */
import React from 'react';
import { ComponentRenderer } from './ComponentRenderer';
import * as AllComponents from './components/pageComponents';

interface PageComponentRendererProps {
  components?: Queries.PageComponentsComponentsFragment[];
}

export const PageComponentRenderer = ({
  components,
}: PageComponentRendererProps) => (
  <ComponentRenderer components={components} allComponents={AllComponents} />
);
